export const ERROR_CODE = {
  lineAccountAlreadyRegistered: 'line_account_already_registered'
}
